import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { HospitalService } from '../../_service/hospital.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
declare var $: any;
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-hospital',
  templateUrl: './hospital.component.html',
  styleUrls: ['./hospital.component.css']
})
export class HospitalComponent implements OnInit {

    @ViewChild('paginatorBottom', {static: false}) paginatorBottom: MatPaginator; 
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('csvHospitalRankingFieldUpdate', {static: false}) csvHospitalRankingFieldUpdate: ElementRef;
    @ViewChild('csvUpload', { static: false }) csvUpload: ElementRef;
    perpage:number=25;hospitalsList:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;
    pageSizeOptions = [10,25,50,100];pageIndex:number=0;loaded:boolean=false;cities=[];city='';circles=[];circle='';
    search:string;sc3Url='';status='';circles_copy=[];submitted:boolean=false;uploaded_msg: string = '';userId:string;
    constructor(private hospitalapi:HospitalService,private sharedapi:SharedService,public leadapi:LeadsService) { }

    ngOnInit(): void 
    {
        this.getcircle();
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.sc3Url = localStorage.getItem('s3url');
        this.userId = localStorage.getItem('loginuserId');
    }

    hideRankingStatusUpdateModal()
    {
        $('#myModalLeadStatusUpdate').modal('hide');
    }

    showRankingStatusUpdateModal()
    {
        $('#myModalLeadStatusUpdate').modal();
    }

    async rankingUpdate(event)
    {
        this.submitted = true;
        let file = event.target.files.item(0);
        const formData = new FormData();
        formData.append('file', file);
        this.hospitalapi.uploadcsvHospitalRankingUpdate(formData)
        .subscribe((data:any) => {
            this.submitted = false;
            this.csvHospitalRankingFieldUpdate.nativeElement.value = "";
            if(data.status){
                this.sharedapi.presentToast(data.msg);
            }else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }

    setSearchValue(){
        $("#circleSearch").val('');
        $("#circleSearch").focus();
        this.circles= this.circles_copy;
    }

    searchOnSelect(searchtText: string, type){
        if (type == 'circle') {
            this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
        }
    }

    ngAfterViewInit() {
         this.loadHospitalsList(0,this.perpage);
    }

    showOnLP(event,id,index){
        let status;
        if(event.checked){
            status=1;
        }else{
            status=0;
        }
        let value = {
            'id':id,
            'display_on_LP':status
        }
        this.hospitalapi.showingOnLP(value)
        .subscribe((data:any) => {
            if(data.status)
            {
                this.sharedapi.presentToast('Data Updated Successfully');
                this.hospitalsList[index].display_on_LP=data.data.display_on_LP;
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
        }, error => 
        {
            this.sharedapi.checkError(error);
        }); 

    }
    
    onStatusChange(event,id,index){
        let status;
        if(event.checked){
            status=1;
        }else{
            status=0;
        }
        let value = {
            'id':id,
            'status':status
        }
        this.hospitalapi.updateHospitalStatus(value)
        .subscribe((data:any) => {
            if(data.status)
            {
                this.sharedapi.presentToast('Status Update Successfully');
                this.hospitalsList[index].status=data.data.status;
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
        }, error => 
        {
            this.sharedapi.checkError(error);
        }); 

    }

    async loadHospitalsList(pageIndex,perpage)
    {   
        this.hospitalsList = [];
        this.paginator.pageIndex = pageIndex; 
        this.paginatorBottom.pageIndex = pageIndex;
        this.pageIndex = pageIndex;
        let qString = 'search='+this.search+'&circle='+this.circle+'&status='+this.status;
        this.loading = true;this.loaded = false;
        this.hospitalapi.getHospitalList(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
        	this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.hospitalsList = data.data;
            }else{
                this.hospitalsList = [];
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadHospitalsList(event.pageIndex,event.pageSize);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadHospitalsList(event.pageIndex,event.pageSize);
    }

    async getcircle()
    {
        this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
                this.circles_copy = this.circles;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    async getcity()
    {
        this.leadapi.getcities().subscribe((data:any) => {
            if(data.status)
            {
                this.cities = data.data;
            }else{
                this.cities = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    exportHospitalList()
    {
        if(this.hospitalsList.length>0)
        {
            let data = [];
            let titles = ['Name','Contact Number','Circle','City','Hospital Registration Certificate','Bio Medical Waste Certificate','NABH','MTP Certificate (For Gynae branch)','tge hospital agreement','Packages','Hospital Images','Status'];

            data.push(titles);
            for(let key in this.hospitalsList)
            {   
                
                let registrationCertificate= 'Not Uploaded';
                if(this.hospitalsList[key].uploadedfiles[1].length)
                registrationCertificate= 'Uploaded';
                let BioWaste= 'Not Uploaded';
                if(this.hospitalsList[key].uploadedfiles[2].length)
                BioWaste= 'Uploaded';
                let nabh= 'Not Uploaded';
                if(this.hospitalsList[key].uploadedfiles[3].length)
                nabh= 'Uploaded';
                let mtp= 'Not Uploaded';
                if(this.hospitalsList[key].uploadedfiles[4].length)
                mtp= 'Uploaded';
                let tge= 'Not Uploaded';
                if(this.hospitalsList[key].uploadedfiles[5].length)
                tge= 'Uploaded';
                let packages= 'Not Uploaded';
                if(this.hospitalsList[key].uploadedfiles[6].length)
                packages = 'Uploaded';
                let hospitalimage= 'Not Uploaded';
                if(this.hospitalsList[key].uploadedfiles[7].length)
                hospitalimage= 'Uploaded';
                
                let Status;
                if(this.hospitalsList[key].status=='1'){
                    Status='Active'; 
                }else if(this.hospitalsList[key].status=='0'){
                    Status='In-Active'; 
                }else{
                    Status='Deleted'; 
                }

                let exdata = [this.hospitalsList[key].name,this.hospitalsList[key].mobile,this.hospitalsList[key].circle_name,this.hospitalsList[key].cityName,registrationCertificate,BioWaste,nabh,mtp,tge,packages,hospitalimage,Status];
                
                data.push(exdata)
            }
            let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'hospital_'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('Something went wrong, Try Again!');
        }
    }

    resetFilters()
    {
        this.search = ''; this.circle = ''; this.status = '';
        this.loadHospitalsList(0,25);
    }

//------------------------Csv for update Hospital data-----------------------------//
    hideModal() {
        this.uploaded_msg = '';
        $('#updateDataModal').modal('hide');
    }

    showModal() {
        this.uploaded_msg = '';
        $('#updateDataModal').modal();
      }

      async selectFile(event) {
        this.submitted = true;
        let file = event.target.files.item(0);
        const formData = new FormData();
        formData.append('file', file);
        this.uploaded_msg = "";
        this.hospitalapi.updateHospitalDataFromCsv(formData).subscribe((data: any) => {
          this.submitted = false;
          this.csvUpload.nativeElement.value = "";
          if (data.status) {
            this.uploaded_msg = data.msg;
          }
          else {
            this.sharedapi.presentToast(data.msg);
          }
        }, error => {
          this.sharedapi.checkError(error);
        });
      }

}

